import {availableColors} from "../../utilities/availableColors";


export class ZoneDataGenerator {

    static generateName(alreadyExistsNames: string[], prefix: string='Zone') {
        let i = 1;
        let newName = '';
        while (alreadyExistsNames.includes(newName) || newName === '') {
            newName = prefix + ' ' + this.convertNumberToLetter(i);
            i++;
        }
        return newName;
    }

    // convert numbers to letters like in excel
    static convertNumberToLetter(number: number) {
        let result = '';
        while (number > 0) {
            let remainder = number % 26;
            if (remainder === 0) {
                remainder = 26;
            }
            result = String.fromCharCode(remainder + 64) + result;
            number = (number - remainder) / 26;
        }
        return result;
    }

    static generateColor(alreadyExistsColors: string[], availableColors: string[]): string {
        let newColor = '';
        // find last color from alreadyExistsColors used in availableColors
        for (let i = alreadyExistsColors.length - 1; i >= 0; i--) {
            if (availableColors.includes(alreadyExistsColors[i])) {
                newColor = alreadyExistsColors[i];
                break;
            }
        }
        // get next color from availableColors
        let index = availableColors.indexOf(newColor);
        if (index === -1) {
            index = 0;
        } else {
            index++;
        }
        if (index >= availableColors.length) {
            index = index - availableColors.length;
        }
        newColor = availableColors[index];
        return newColor;
    }


}